export default __webpack_public_path__ + "static/media/Dhanush_Resume.5118e675.pdf";